import React from 'react';
import PulseLogoLoader from './PulseLogoLoader';

const LoadingScreen = ({ message = "Loading..." }) => {
    return <PulseLogoLoader text={message} />;
};

export default LoadingScreen;
